import { ApplicationParenthesesOutlineIcon } from './ApplicationParenthesesOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 9FA63D08-5057-4AA3-9FD0-367B8AE55352
 * name application-parentheses-outline
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-parentheses-outline.svg
 * tags
 * - Developer / Languages 
 */
export const IframeParenthesesOutlineIcon = ApplicationParenthesesOutlineIcon;
export default IframeParenthesesOutlineIcon